// A disclosure is a widget that enables content to be either collapsed (hidden) or expanded (visible)
// https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/

// This class is instantiated for all elements with [aria-expanded] and [aria-controls] attributes
// It can be used to create a disclosure widget for any element that can be hidden or shown

class Disclosure {
    constructor(button) {
        this.button = button;

        this.init();
    }

    init() {
        this.button.addEventListener("click", this.toggle.bind(this));
        this.id = this.button.getAttribute("aria-controls");
        this.target = document.getElementById(this.id);

        // Disclosures default to being closed. If you need them to default to being open use resetAria()

        // Sidebar breakpoint
        if (window.matchMedia("(min-width: 65.4375em)").matches) {
            if (this.id == "applicationDetails") this.resetAria();
        }
    }

    toggle() {
        const buttons = document.querySelectorAll(
            "[aria-controls='" + this.id + "']",
        );
        const expanded = this.button.getAttribute("aria-expanded") === "true";

        buttons.forEach((button) => {
            button.setAttribute("aria-expanded", !expanded);
        });
        this.target.setAttribute("aria-hidden", expanded);
    }

    scrollIntoView() {
        const page_header = document.querySelector(".page-header__sticky");
        if (page_header) {
            page_header.scrollIntoView(true);
        } else if (this.target) {
            this.target.scrollIntoView(true);
        }
    }

    resetAria() {
        this.button.setAttribute("aria-expanded", "true");
        this.target.setAttribute("aria-hidden", "false");
    }
}

// Instantiate the class for all [aria-expanded][aria-controls] elements on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll("[aria-expanded]");

    elements.forEach((element) => {
        new Disclosure(element);
    });
});

export default Disclosure;
